export const MAX_RESULT_SEARCH_ITEMS = 10;
export const BUTTON_ICON = 'bookmarkBorder';
export const ACTIVE_BUTTON_ICON = 'bookmark';
export const FAVOURITE_STATIONS_BUTTON_ID = 'favourite-stations-show';
